"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterGroupEnum = exports.FilterTypeEnum = void 0;
var FilterTypeEnum;
(function (FilterTypeEnum) {
    FilterTypeEnum["CALENDAR"] = "calendar";
})(FilterTypeEnum = exports.FilterTypeEnum || (exports.FilterTypeEnum = {}));
var FilterGroupEnum;
(function (FilterGroupEnum) {
    FilterGroupEnum["CUSTOM"] = "custom";
    FilterGroupEnum["ORGANIZATION"] = "organization";
    FilterGroupEnum["SYSTEM"] = "system";
})(FilterGroupEnum = exports.FilterGroupEnum || (exports.FilterGroupEnum = {}));
//# sourceMappingURL=filter.enums.js.map